export const parseHtmlAndReplaceUrls = (html: string, baseUrl: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const elementsWithUrls = doc.querySelectorAll('a, img');

  elementsWithUrls.forEach((element) => {
    const attr = element.tagName === 'A' ? 'href' : 'src';
    const url = element.getAttribute(attr);

    if (url && !url.startsWith('http') && !url.startsWith('//')) {
      element.setAttribute(attr, new URL(url, baseUrl).href);
    }
  });

  return doc.documentElement.innerHTML;
};

export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // Remove non-word chars except hyphens
    .replace(/--+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};
